import React from 'react'
import { Alert } from 'components'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { alerts } from 'keys'
import { PerformAssessmentAgainStyles } from './Style'
import { useSelector } from 'react-redux'
import { alerts as alertKeys } from 'keys'

const AssessmentCompletionAlert = () => {
    const dispatch = useDispatch()
    const { alerts } = useSelector(state => state.general)

    const handleAlert = (val) => {
        dispatch(actions.setAlerts({ key: alertKeys.performAssessmentAgain, value: { open: val } }))
    }

    const footerActions = React.useMemo(() => [
        {
            label: "ביטול", color: "thirdly4",
            action: () => {
                handleAlert(false)
            }
        },
        {
            label: "כן, לאפס", color: "error",
            action: () => {
                handleAlert(false)
                alerts[alertKeys.performAssessmentAgain].props.onClose()
            }
        }
    ], [])

    return (
        <Alert
            type="danger"
            systemUI
            footerActions={footerActions}
            title="המבדק שבוצע יתאפס ולא יינתן לשחזור"
            handleAlert={handleAlert}
        >
            <PerformAssessmentAgainStyles>
                {"האם לאפס את המבדק הקיים ולבצע מחדש?"}
            </PerformAssessmentAgainStyles>
        </Alert>
    )
}

export default AssessmentCompletionAlert